import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material';

import { PurchaseOrderFilterService } from './purchase-order.filter.service';
import { ConnectionService } from '../connections/connection.service';
import { parseErrors } from '../shared/api.service';
import { clone, find as _find, reject } from 'lodash';

@Component({
  selector: 'purchase-order-filter-dialog',
  templateUrl: './purchase-order-filters-dialog.component.html',
  styleUrls: ['./purchase-order-filters-dialog.component.scss'],
  providers: [
    PurchaseOrderFilterService, ConnectionService
  ]
})
export class PurchaseOrderFiltersDialogComponent implements OnInit {
  loading = false;
  errors = [];
  products = [];
  productsConfig = {
    nameProperty: 'name',
    searchable: true,
    loadingOptions: false
  };
  locations = [];
  locationsConfig = {
    nameProperty: 'name',
    searchable: true,
    loadingOptions: false
  };
  customers = [];
  customersConfig = {
    nameProperty: 'name',
    searchable: true,
    loadingOptions: false
  };
  @ViewChild('productsDropdown', { static: false }) productsDropdown;
  @ViewChild('customersDropdown', { static: false }) customersDropdown;
  @ViewChild('locationsDropdown', { static: false }) locationsDropdown;
  callback;
  model = {
    delivery_location: null,
    customer_organization: null,
    product: null,
    fulfilled: false,
    full_stop: false,
    void: false
  };
  productsReq;
  customersReq;
  locationsReq;

  constructor(
    private purchaseOrderFilterService: PurchaseOrderFilterService,
    private connectionService: ConnectionService,
    public dialogRef: MatDialogRef<PurchaseOrderFiltersDialogComponent>
  ) { }

  ngOnInit() {
    this.getProducts();
    this.getCustomers();
    this.getLocations();
  }

  onSelect(filterType, e) {
    this.model[filterType] = e;
  }

  submit() {
    this.callback(this.model);
    this.dialogRef.close();
  }

  getProducts(search = null) {
    this.products = [];
    this.productsConfig.loadingOptions = true;
    this.productsConfig = clone(this.productsConfig);
    if (this.productsReq) { this.productsReq.unsubscribe(); }

    this.productsReq = this.purchaseOrderFilterService.listFilters(
      'products', search
    ).subscribe(products => {
      this.products = products;
      if (this.model.product) {
        let selectedOption = _find(this.products, { id: this.model.product.id });
        this.products = reject(this.products, selectedOption);
        this.products.unshift(this.model.product);
        this.productsDropdown.selectedOption = selectedOption;
      }
      this.productsDropdown.config.loadingOptions = false;
      this.productsConfig.loadingOptions = false;
    }, err => {
      this.errors = err;
      this.loading = false;
      this.productsDropdown.config.loadingOptions = false;
      this.productsConfig.loadingOptions = false;
      this.productsConfig = clone(this.productsConfig);
    });
  }

  getCustomers(search = null) {
    if (this.customersReq && typeof this.customersReq.unsubscribe === 'function') {
      this.customersReq.unsubscribe();
    }

    this.customersReq = this.purchaseOrderFilterService.listFilters(
      'customers', search
    ).subscribe(customers => {
      this.customers = customers;
      if (this.model.customer_organization) {
        let selectedOption = _find(this.customers, { id: this.model.customer_organization.id });
        this.customers = reject(this.customers, selectedOption);
        this.customers.unshift(this.model.customer_organization);
        this.customersDropdown.selectedOption = selectedOption;
      }
      this.customersDropdown.config.loadingOptions = false;
      this.customersConfig.loadingOptions = false;
    }, err => {
      this.errors = err;
      this.customersConfig.loadingOptions = false;
    });
  }

  getLocations(search = null) {
    if (this.locationsReq && typeof this.locationsReq.unsubscribe === 'function') {
      this.locationsReq.unsubscribe();
    }

    this.locationsReq = this.purchaseOrderFilterService.listFilters(
      'locations', search
    ).subscribe(locations => {
      this.locations = locations;
      if (this.model.delivery_location) {
        let selectedOption = _find(this.locations, { id: this.model.delivery_location.id });
        this.locations = reject(this.locations, selectedOption);
        this.locations.unshift(this.model.delivery_location);
        this.locationsDropdown.selectedOption = selectedOption;
      }
      this.locationsDropdown.config.loadingOptions = false;
      this.locationsConfig.loadingOptions = false;
    }, err => {
      this.errors = err;
      this.locationsConfig.loadingOptions = false;
    });
  }

  dropdownNextPage(e, type) {
    let config;
    let filterType;
    let options;

    switch (type) {
      case 'customer':
        filterType = 'customers';
        config = this.customersConfig;
        options = this.customers;
        break;
      case 'product':
        filterType = 'products';
        config = this.productsConfig;
        options = this.products;
        break;
      case 'location':
        filterType = 'locations';
        config = this.locationsConfig;
        options = this.locations;
        break;
    }

    if (!config.loadingOptions) {
      let o = this.purchaseOrderFilterService.listNext();
      if (o) {
        config.loadingOptions = true;
        o.subscribe(
          results => {
            switch (type) {
              case 'customer':
                this.customers = this.customers.concat(results);
                break;
              case 'product':
                this.products = this.products.concat(results);
                break;
              case 'location':
                this.locations = this.locations.concat(results);
                break;
            }
            config.loadingOptions = false;
          }, (err) => {
            this.errors = parseErrors(err);
            config.loadingOptions = false;
          }
        );
      }
    }
  }

  dropdownSearch(term = '', type) {
    switch (type) {
      case 'customer':
        this.getCustomers(term);
        break;
      case 'product':
        this.getProducts(term);
        break;
      case 'location':
        this.getLocations(term);
        break;
      default:
        throw 'invalid dropdown type';
    }
  }
}
